const OPZIONI = [
    "I18N",
    "OPZIONE",
    "APP"
];


export default OPZIONI;